export const ApplicationStatus = [
  { label: 'message.common.enable', value: '1' },
  { label: 'message.common.disable', value: '2' },
];
